<template>
  <div class="mb-15">
    <div :class="$vuetify.breakpoint.smAndUp && 'px-5'">
      <p class="font-weight-bold secondary--text mb-5">{{ $t('label.orderId') }} {{ item.po_number }}</p>
      <div v-for="orderItem in item.items" :key="orderItem.order_id" class="d-flex flex-column mb-4">
        <div class="d-flex flex-row">
          <img :src="orderItem.product_image" class="mr-5 order-image rounded-lg elevation-3" />
          <div class="w-100 d-flex flex-column flex-sm-row justify-space-between">
            <div>
              <p class="text-subtitle-2 font-weight-bold grey--text">
                {{ orderItem.product_subcategory_name }}
              </p>
              <p class="text-body secondary--text">
                {{ orderItem.product_name }}
              </p>
              <p class="text-body secondary--text">
                {{ orderItem.product_volume_variation_name }}
              </p>
              <div v-if="!toReview && $vuetify.breakpoint.lgAndUp">
                <Rating :value="orderItem.star" class="my-4" dense readonly />
                <p class="text-subtitle-2 grey--text">{{ orderItem.comment }}</p>
                <div class="d-flex mt-4 mb-2">
                  <img
                    v-for="image in orderItem.images"
                    :key="image.id"
                    :src="image.path"
                    :width="$vuetify.breakpoint.smAndUp ? ($vuetify.breakpoint.mdAndUp ? 120 : 100) : 80"
                    :height="$vuetify.breakpoint.smAndUp ? ($vuetify.breakpoint.mdAndUp ? 120 : 100) : 80"
                    class="rounded-lg mr-5"
                  />
                </div>
              </div>
            </div>
            <v-btn
              v-if="toReview"
              color="primary"
              class="ml-md-auto px-md-10 rounded-pill green-gradient-right text-capitalize align-self-center"
              :to="{ name: $constants.ROUTE_NAME.PRODUCT_REVIEW_WRITE, params: { poNum: item.po_number, orderId: item.order_id, item: orderItem } }"
            >
              {{ $t('button.writeReview') }}
            </v-btn>
          </div>
        </div>
        <div v-if="!toReview && !$vuetify.breakpoint.lgAndUp">
          <Rating :value="orderItem.star" class="my-4" dense readonly />
          <p class="text-subtitle-2 grey--text">{{ orderItem.comment }}</p>
          <div class="d-flex mt-4 mb-2 flex-wrap">
            <img
              v-for="image in orderItem.images"
              :key="image.id"
              :src="image.path"
              :width="$vuetify.breakpoint.smAndUp ? ($vuetify.breakpoint.mdAndUp ? 120 : 100) : 80"
              :height="$vuetify.breakpoint.smAndUp ? ($vuetify.breakpoint.mdAndUp ? 120 : 100) : 80"
              class="rounded-lg mr-2 mr-md-3 mr-lg-5 my-1 my-md-0"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Rating from '@/components/Rating.vue'
export default {
  props: {
    item: {
      type: Object,
      required: true
    },
    toReview: {
      type: Boolean,
      default: true
    }
  },
  components: { Rating }
}
</script>

<style lang="scss" scoped>
.order-image {
  width: 100px;
  height: 100px;
  object-fit: cover;

  @media only screen and (min-width: 640px) {
    width: 120px;
    height: 120px;
  }
  @media only screen and (min-width: 1500px) {
    width: 150px;
    height: 150px;
  }
}
</style>
